import { LoadableLazy } from '@confluence/loadable';

export const ViewChangesDialogLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewChangesDialog" */ './ViewChangesDialog.tsx'))
			.ViewChangesDialog,
});
